import { navigationBreakPoint } from '../theme/breakpoints';

import HomeIcon from './assets/home.svg';
import AssignmentsIcon from './assets/assignments.svg';
import BoardsIcon from './assets/boards.svg';
import MessagesIcon from './assets/messages.svg';
import CatalogIcon from './assets/materials.svg';
import ClassesIcon from './assets/classes.svg';
import TestsIcon from './assets/tests.svg';
import StudyPlanIcon from './assets/study-plan.svg';

export interface INavigationItem {
  name: string; // as the caption locale key
  mobileName?: string; // as the caption locale key for mobile
  caption?: string; // as the caption locale key, when it is not the name
  path: string;
  color: string;
  isDynamic?: boolean;
  badgeCount?: number;
  icon?: string;
}

export const homeItem: INavigationItem = {
  name: 'home',
  path: '/',
  color: '#37D3FD',
  icon: HomeIcon
};

export const catalogItem: INavigationItem = {
  name: 'catalog',
  path: '/catalog',
  color: '#F75BA8',
  icon: CatalogIcon
};

export const learningMaterialsItem: INavigationItem = {
  name: 'learning_materials',
  mobileName: 'materials',
  path: '/learning-materials',
  color: '#FEC32D',
  icon: CatalogIcon
};

export const meetingsItem: INavigationItem = {
  name: 'meetings',
  path: '/meetings',
  color: '#D12379',
  icon: ClassesIcon
};

export const liveClassesItem: INavigationItem = {
  name: 'live_classes',
  path: '/live-classes',
  color: '#F7409B',
  icon: ClassesIcon
};

export const studyPlanItem: INavigationItem = {
  name: 'study_plan',
  path: '/study-plan',
  color: '#4FE3A1',
  icon: StudyPlanIcon
};

export const assignmentsItem: INavigationItem = {
  name: 'assignments',
  path: '/assignments',
  color: '#B283FF',
  icon: AssignmentsIcon
};

export const testsItem: INavigationItem = {
  name: 'tests',
  path: '/tests',
  color: '#FC9B66',
  icon: TestsIcon
};

export const boardsItem: INavigationItem = {
  name: 'boards',
  caption: 'activities',
  path: '/boards',
  color: '#CDE42D',
  icon: BoardsIcon
};

const _settingsItem: INavigationItem = {
  name: 'settings',
  path: '/settings',
  color: '#BED62F'
};

export const tabBarItems: INavigationItem[] = [
  homeItem,
  boardsItem,
  learningMaterialsItem,
  assignmentsItem,
  testsItem
];

export {
  HomeIcon,
  CatalogIcon,
  AssignmentsIcon,
  BoardsIcon,
  MessagesIcon,
  StudyPlanIcon
};

export const navigationMediaQuery = `@media(min-width:${navigationBreakPoint}px)`;
